<div *ngIf="loading; else loadingCompleted" class="spinner">
  <nz-spin nzSimple></nz-spin>
</div>

<ng-template #loadingCompleted>
  <div
    class="documentTable"
    infiniteScroll
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="8"
    (scrolled)="onScroll()"
    [scrollWindow]="false"
    [infiniteScrollContainer]="'.documentTable .ant-table-body'"
  >
    <va-custom-grid
      (sortChange)="sort($event)"
      [columnsData]="props.columnsData"
      [widthConfig]="props.widthConfig"
      [bordered]="props.bordered"
      [fields]="props.fields"
      [data]="listOfData"
      [gridHeight]="gridHeight"
      [showPagination]="false"
    ></va-custom-grid>
  </div>
</ng-template>
